module.exports = function () {
    return {
        restrict: 'E',
        link(scope, element) {
            const input = element.find('.input-file')[0],
                  label = input.nextElementSibling,
                  labelVal = label.innerHTML;

            input.addEventListener('change', function (e) {
                let fileName = '';

                if (this.files && this.files.length > 1) {
                    fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                } else {
                    fileName = e.target.value.split('\\').pop();
                }

                if (fileName) {
                    const element = $('.clear-input--file').find('#filename');
                    if (element) {
                        element.html(fileName)
                    }

                } else {
                    label.innerHTML = labelVal;
                }
            });

            // Firefox bug fix
            input.addEventListener('focus', function () {
                input.classList.add('has-focus');
            });
            input.addEventListener('blur', function () {
                input.classList.remove('has-focus');
            });

            scope.clearInput = function () {
                label.innerHTML = labelVal;
                input.value = null;
            };
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/input-file-upload/input-file-upload-directive.js
 **/